import axios from 'axios';
import { Message } from 'element-ui';
import router from '../router';

// axios 配置
axios.defaults.timeout = 20000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.baseURL = '/jfApi/web';
axios.defaults.withCredentials = true;

// POST传参序列化
axios.interceptors.request.use(
    config => {
        config.headers.Authorization = localStorage.getItem('authorization');
        return config;
    },
    error => {
        console.log('参数错误');
        return Promise.reject(error);
    },
);

// 返回状态判断
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if (!response.data.success && response.config.url.indexOf('userInfo/query') < 0) {
                if (response.data.code === 401) {
                    router.push({ path: '/login' });
                    return Promise.reject();
                }
                Message.error(response.data.msg);
                return Promise.reject();
            }
            return response;
        } else {
            Promise.reject();
        }
        return response.data;
    },
    error => {
        console.log('网络异常');
        return Promise.reject(error);
    },
);

export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, { params })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function uploadFile(url, params) {
    const param = new FormData();
    Object.keys(params)
        .filter(key => params[key])
        .forEach(key => {
            param.append(key, params[key]);
        });
    const config = {
        headers: { 'Content-Type': 'multipart/form-data' },
    };
    return new Promise((resolve, reject) => {
        axios
            .post(url, param, config)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}
